export default "__VITE_ASSET__BjOwYPMJ__"